import Axios from "axios";

const API_URL_V3 = process.env.API_URL + "/api/v3/data/addresses/";

class Kecamatan {
  index(city_id) {
    return Axios.get(API_URL_V3 + `districts?city_id=${city_id}&order_column=name&order_direction=asc`);
  }

  show(district_id) {
    return Axios.get(API_URL_V3 + `districts/${district_id}`);
  }
}

export default new Kecamatan();



// WEBPACK FOOTER //
// ./src/api/daerahindonesia/kecamatan.js